import { GetStaticProps, InferGetStaticPropsType, GetStaticPaths } from 'next';
import { PostListPage } from '@components';
import { hnaviTitle } from '@constants';
import { calcPageCountFromPostCount } from '@utils';
import { useCanonical } from '@hooks';
import { getStaticPropsCore } from '@/src/getStatic/hnaviCategoryGetStaticPropsCore';
import { getStaticPathsCore } from '@/src/getStatic/hnaviCategoryGetStaticPathsCore';

const getBreadcrumbs = ({
  hnaviCategory,
  pageTitle,
}: {
  hnaviCategory: { name: string; code: string };
  pageTitle: string;
}) => [
  {
    text: hnaviTitle,
    url: '/',
  },
  {
    text: hnaviCategory.name,
    url: `/${hnaviCategory.code}`,
  },
  {
    text: pageTitle,
  },
];

const Page: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = ({
  hnaviCategory,
  pageTitle,
  hnaviReferenceKey,
  ...rest
}) => {
  const canonical = useCanonical();
  return (
    <PostListPage
      {...rest}
      useHnaviHeader
      seoData={{ title: `${pageTitle} | ${hnaviTitle}`, canonical }}
      pageCount={calcPageCountFromPostCount(
        rest.posts.pageInfo?.offsetPagination?.total ?? 0
      )}
      pageTitle={pageTitle}
      breadcrumbs={getBreadcrumbs({ hnaviCategory, pageTitle })}
      paginationBasePath={`/${hnaviCategory.code}/${hnaviReferenceKey}`}
    />
  );
};

export default Page;

export const getStaticProps = ({
  params,
}: Parameters<
  GetStaticProps<any, { hnaviCategory: string; pageNo: string }>
>[0]) => getStaticPropsCore({ params, hnaviReferenceKey: 'cost' });

export type PathParams = { hnaviCategory: string; pageNo: string };

export const getStaticPaths: GetStaticPaths<PathParams> = () =>
  getStaticPathsCore({ hnaviReferenceKey: 'cost' });
